<table class="table table-hover share-record-desktop-table my-sharing-center">
  <thead>
    <tr class="thead">
      @for (column of columns; track column) {
        <th
          class="normal-text text-semi-black-gray"
          >
          {{ column.header }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows; track row) {
      <tr>
        @for (column of columns; track column) {
          <td>
            @if (column.render) {
              <ng-container
                *ngComponentOutlet="column.render(); inputs: { row: row }"
              ></ng-container>
            } @else {
              <lib-dynamic-column
                [columnType]="column.type"
                [columnData]="row[column.key]"
              ></lib-dynamic-column>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
